import type { IBalanceTransaction, IBalanceTransactionFilters } from '@/types/asicw/balance'
import axios from 'axios'

export async function getBalanceTransactions(filters: IBalanceTransactionFilters): Promise<IBalanceTransaction[]> {
  const res = await axios.get(import.meta.env.VITE_APP_ASICW_BALANCE_ENDPOINT, { params: filters })
  return res.data
}

export async function exportBalanceTransactionsCSV(filters: IBalanceTransactionFilters): Promise<Blob> {
  const res = await axios.get(`${import.meta.env.VITE_APP_ASICW_BALANCE_ENDPOINT}/export`, {
    params: filters,
    responseType: 'blob',
  })
  return res.data
}
